import React, { Component } from 'react';
// main layout imports
import { Layout } from 'antd';
import PropTypes from 'prop-types';
const { Content } = Layout;

class Empty extends Component {
	render() {
		return (
			<Layout className="mainLayout">
				<Content className="content">{this.props.children}</Content>
			</Layout>
		);
	}
}

Empty.propTypes = {
	children: PropTypes.object.isRequired,
};

export default Empty;
